// client/src/components/OurWork/OurWork.js (NEW)

import React from 'react';
import './OurWork.css';

// 1. Import your new images
import workImg1 from '../../assets/work-image-1.jpg';
import workImg2 from '../../assets/work-image-2.jpg';
import workImg3 from '../../assets/work-image-3.jpg';
import workImg4 from '../../assets/work-image-4.jpg';
import workImg5 from '../../assets/work-image-5.jpg';

const OurWork = () => {
  return (
    <section id="work" className="section work-section">
      <div className="work-header">
        <h2>Our Work</h2>
        <p>
          At Om Nidhi Productions, creativity meets precision. Our portfolio
          reflects a blend of visual artistry, professional production, and
          innovative storytelling that resonates with audiences and brands alike.
        </p>
        <p>
          We have proudly collaborated on projects across multiple creative
          domains — from fashion to film, and advertising to brand
          storytelling.
        </p>
      </div>

      {/* 2. Add the new Image Gallery */}
      <div className="work-gallery">
        <img src={workImg1} alt="Om Nidhi Production - Kiara Advani Shoot" />
        <img src={workImg2} alt="Om Nidhi Production - Studio BTS" />
        <img src={workImg5} alt="Om Nidhi Production - Fashion Runway" />
        <img src={workImg4} alt="Om Nidhi Production - Photo Shoot" />
        <img src={workImg3} alt="Om Nidhi Production - Clapperboard" />
      </div>

      {/* 3. Keep the existing text grid */}
      <div className="work-grid">
        <div className="work-category">
          <h3>👗 Fashion Shows & Events</h3>
          <p>
            We have organized and managed high-end fashion shows featuring
            talented designers, emerging models, and creative stylists. Our team
            handles everything from concept creation, choreography, stage
            design, and media coverage.
          </p>
          <h4>Key Highlights:</h4>
          <ul>
            <li>Annual “Runway Reimagined” Fashion Showcase</li>
            <li>Model Talent Hunt Events</li>
            <li>Designer Launch Shows and Brand Exhibitions</li>
          </ul>
        </div>
        <div className="work-category">
          <h3>🎬 Advertising & Brand Promotions</h3>
          <p>
            We collaborate with brands to tell their stories through visually
            captivating TV commercials, digital ads, and social media
            campaigns. Our approach merges creativity with market understanding.
          </p>
          <h4>Scope of Work:</h4>
          <ul>
            <li>Ad Films and Commercial Shoots</li>
            <li>Brand Campaigns and Product Launches</li>
            <li>Social Media Content Creation and Management</li>
          </ul>
        </div>
        <div className="work-category">
          <h3>📸 Photo Shoots & Modeling Projects</h3>
          <p>
            Our in-house production and photography team has executed numerous
            professional portfolio shoots, brand campaigns, and creative
            concept shoots.
          </p>
          <h4>Specialties:</h4>
          <ul>
            <li>Model Portfolio Shoots</li>
            <li>Product & Brand Photography</li>
            <li>Fashion Editorials and Outdoor Concept Shoots</li>
          </ul>
        </div>
      </div>
      {/* Note: I removed the Talent/Music categories to make the grid 
          a cleaner 3-column layout to match the images. 
          We can add them back if you prefer. */}
    </section>
  );
};

export default OurWork;